import { isApplePayEnabled } from '@/utils/environment'
import ApplePayConfigs from '@/utils/ApplePay/configs'

const calculateTotalValue = (selectedInstallment) => {
  return selectedInstallment.subtotal
    ? selectedInstallment.subtotal
    : selectedInstallment.value * selectedInstallment.installment
}

const createInterestItem = (value, cart) => {
  return {
    label: 'Taxa de parcelamento',
    amount: {
      currency: 'BRL',
      value: (value - cart.total).toFixed(2),
    },
  }
}

const shouldDisplayApplePay = ({ state }) => {
  if (!isApplePayEnabled()) {
    return false
  }
  const applePayInstance = state.applePay()
  return applePayInstance.isApplePaySupported()
}

const actions = {
  isApplePaySupported: ({ state }) => {
    return shouldDisplayApplePay({ state })
  },

  filterApplePayPayment: ({ state }, originalList) => {
    const shouldKeepApplePayInList = shouldDisplayApplePay({ state })
    return originalList.filter((item) => {
      if (item.option?.value === ApplePayConfigs.key) {
        return shouldKeepApplePayInList
      }
      return true
    })
  },

  processApplePayPayment: async ({ state }, { cart, installment }) => {
    const selectedInstallment = cart.installments.find((item) => item.installment === +installment)
    const hasInstallments = +installment > 1
    const value = calculateTotalValue(selectedInstallment, cart)

    const cartItems = [
      {
        label: 'Frete',
        amount: {
          currency: 'BRL',
          value: cart.freight,
        },
      },
      ...(hasInstallments ? [createInterestItem(value, cart)] : []),
      ...cart.items.bundles.map((item) => ({
        label: `${item.name} (${item.qty}x)`,
        amount: {
          value: item.price,
          currency: item.currency_code || 'BRL',
        },
      })),
    ]

    const paymentDetails = {
      total: {
        label: cart.store_name,
        amount: { value: value.toFixed(2), currency: cart.currency_code || 'BRL' },
      },
      displayItems: cartItems,
    }

    const applePayInstance = state.applePay(cart, installment)
    return applePayInstance.execute(paymentDetails)
  },
}

export default actions
